module.exports = __webpack_public_path__ + "fonts/Inter-Medium.f6cf0a0.woff2";